import { Component } from '@angular/core';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-features-grid-redesign',
  templateUrl: './features-grid-redesign.component.html',
  styleUrls: ['./features-grid-redesign.component.scss']
})
export class FeaturesGridRedesignComponent {

  features: Feature[] = [
    {
      icon: 'icon3.svg',
      title: 'Early-Stage Detection & Predictive Analytics for Mental Health Conditions',
      description: 'Althea Soft platform utilizes specialized AI to predict and detect early-stage mental health and neurological conditions, including Alzheimers, dementia, schizophrenia, anxiety, eating disorders like bulimia and anorexia, borderline personality disorder, and ADHD. The technology aims to shift the paradigm from reactive care to proactive prevention by identifying subtle indicators before a crisis develops'
    },
    {
      icon: 'icon3.svg',
      title: 'Volumetric Atrophy Tracking',
      description: 'Our professional, Patented AI-driven neuroimaging analytics platform processes high-resolution structural MRI and CT scans to extract objective biomarkers from complex brain patterns. By correlating volumetric data and subtle structural changes against extensive, peer-reviewed clinical datasets, the system delivers high-precision differential diagnostic support that empowers clinicians to distinguish between complex, overlapping phenotypes much earlier in the disease progression. For more information, visit the platforms official site.'
    },
    {
      icon: 'icon3.svg',
      title: 'Hands-Free AI Assistance',
      description: 'Voice-Activated Workflows, Instant Dictation Engine, Intelligent Diagnostic Predictions and Automated Risk Assessments. Real-time clinical notes into structured records instantly during patient sessions, Switch seamlessly between complex patient metrics, charts, and image views using only vocal cues.'
    },
    {
      icon: 'icon1.svg',
      title: 'Continuous monitoring',
      description: 'Early signs of cognitive and mental health decline don’t appear suddenly. Continuous monitoring captures subtle changes in behavior, vitals, and movement that periodic checks miss.'
    },
    {
      icon: 'icon1.svg',
      title: 'Real-time alerts',
      description: 'Replace delayed reporting with immediate notifications, so clinical teams can respond when risk indicators emerge, not only after a crisis has escalated.'
    },
    {
      icon: 'icon3.svg',
      title: 'AI-driven insights',
      description: 'Not just raw data. AI highlights patterns, risk signals, medication-related changes, and behavioral shifts that are difficult to detect through manual observation alone.'
    },
    {
      icon: 'icon4.svg',
      title: 'Unified care view',
      description: 'Bring monitoring, alerts, patient context, and team coordination into one place, so decisions are faster, handoffs are smoother, and care teams operate with a shared picture of the patient.'
    },

  ];

  trackByTitle(index: number, feature: Feature): string {
    return feature.title;
  }

}